module.exports = __webpack_public_path__ + "img/personnage_choix_2.2bca7876.png";